import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

// Shared field / style constants + tiny formatters used by every Kanban
// sub-component. Kept in a plain .js so components can import without
// pulling in React (utils are pure).

export const inputCls =
  "w-full rounded-lg border border-slate-800 bg-slate-900 text-slate-100 placeholder:text-slate-500 px-3 py-2 outline-none focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-colors";

export const CLIENT_FIELDS = [
  { key: "business_name", label: "Business name" },
  { key: "contact_name", label: "Contact name" },
  { key: "email", label: "Email", type: "email" },
  { key: "phone", label: "Phone" },
  { key: "service_address", label: "Service address" },
  { key: "abn", label: "ABN" },
  { key: "current_service", label: "Current service" },
  { key: "chosen_plan", label: "Chosen plan" },
  { key: "notes", label: "Notes", multiline: true },
];

export const PORT_FIELDS = [
  { key: "external_customer_id", label: "External ID" },
  { key: "current_provider", label: "Current provider" },
  { key: "current_plan_name", label: "Current plan" },
  { key: "current_monthly_fee", label: "Current monthly fee (AUD)", type: "number", step: "0.01" },
  { key: "current_ip", label: "Current IP" },
  { key: "nbn_location_id", label: "NBN location ID" },
  { key: "service_start_date", label: "Service start date", type: "date", hint: "Billing anchor / anniversary" },
  { key: "contract_end_date", label: "Contract end date", type: "date", hint: "Earliest we can transfer without penalty" },
];

export function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtMoney(n) {
  const v = Number(n) || 0;
  return "$" + v.toFixed(2);
}

export async function downloadChaseList(partnerCode) {
  try {
    const resp = await api.get(
      `/commissions/migrations/${partnerCode}/chase-list.csv`,
      { responseType: "blob" },
    );
    const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const cd = resp.headers?.["content-disposition"] || "";
    const m = /filename="([^"]+)"/.exec(cd);
    a.href = url;
    a.download = m?.[1] || `${partnerCode}-chase-list.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("Chase list downloaded");
  } catch (e) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to download chase list");
  }
}
